module.exports = __webpack_public_path__ + "img/bom-details.4106c23d.svg";